export default {
  zh: {
    gold: '金币',
    ruby: '红宝石',
    gRc: '金币记录',
    rRc: '红宝石记录',
    enterId: '请输入要划拨的用户id',
    useG: '可用的金币数量',
    useR: '可用的红宝石数量',
    enterG: '请输入要划拨的金币数量',
    enterR: '请输入要划拨的宝石数量',
    appropriateG: '划拨金币',
    appropriateR: '划拨红宝石',
    send: '发送者',
    rec: '接收者',
    time: '时间',
    more: '更多',
    noNation: '只能给你国家的用户进行充值，如果用户不在你的国家，请联系管理员添加',
    opSuc: '操作成功',
    noSearch: '查询不到该用户',
    isSend: (txt) => {
      return `确定给该用户赠送${txt}吗`
    },
    yes: '确定',
    no: '取消',
    noUid: 'uid不能为空!!',
    Amount: 'Input the amount you want to  transfer',
    sendPl: 'Max 9999999 in 1 time',
    totalTips: 'Please enter the transfer amount',
    transfer: '转账',
    coin_transfer: '硬币转账',
    available_coins: '可用硬币',
    input_user_id_tips1: '输入您要转账的用户ID',
    search_for_user: '搜索用户',
    search: '搜索',
    search_for_user_toast1: '请输入用户ID',
    search_for_user_toast2: '用户不存在',
    input_transfer_coins_tips1: '输入您要转账的金额',
    transfer_toast1: '请输入转账金额',
    tips: '提示',
    transfer_pop_up: '确认将{0}硬币转账至ID:{1}',
    confirm: '确认',
    cancel: '取消',
    transfer_toast2: '该用户和你不是同一个区域的用户，无法转账',
    transfer_toast3: '金币余额不足，转账失败',
    transfer_toast4: '转账成功',
    transfer_message1: '{0}（ID:{1})给你转账了{2}金币，请前去钱包查收',
    transfer_toast5: '充值失败，请稍后重试',
    entering_the_room: '正在进入房间',
    entering_the_room_toast1: '房间不存在',
    entering_the_room_toast2: '你已被禁止进入该房间',
    entering_the_room_toast3: '无法进入非同一大区的房间',
    entering_the_room_toast4: '进入房间失败，请稍后重试',
    add_blacklist_pop_up: '拉进黑名单后，你将不会再收到该用户的消息',
    remove_from_blacklist: '从黑名单移除',
    go_after: '跟随进房',
    bio_empty_contents: '此人很神秘，什么也没留下。',
    received: '收到的',
    sent: '发送',
    day: '天（单数）',
    days: '天（复数）',
    supporters: '支持者',
    vehicle: '座驾',
    headwear: '头饰',
    gift: '礼物',
    no_medal_yet: '暂无勋章',
    no_vehicle_yet: '暂无座驾',
    no_headwear_yet: '暂无头饰',
    no_gifts_received_yet: '暂未收到礼物',
    home: '房间',
  },
  en: {
    gold: 'Gold',
    ruby: 'Ruby',
    gRc: 'Gold Record',
    rRc: 'Ruby Record',
    enterId: 'Please enter the user id to distribute',
    useG: 'Usable Coins',
    useR: 'Number of rubies available',
    enterG: 'Please enter the quantity of gold to be distributed',
    enterR: 'Please enter the number of rubies to distribute',
    appropriateG: 'Distribute gold',
    appropriateR: 'Distribute Ruby',
    send: 'Sender ',
    rec: 'Recipient',
    time: 'Time',
    more: 'More',
    noNation:
      'You can only recharge users in your country. If the user is not in your country, please contact the administrator to add',
    opSuc: 'Operation succeeded',
    noSearch: 'The user cannot be found',
    isSend: (txt) => {
      return `Are you sure to give ${txt} gold coins to this user as a gift`
    },
    yes: 'confirm',
    no: 'cancel',
    noUid: 'uid could not be empty!!',
    loginOut: 'Login Out',
    usableCoins: 'Usable Coins',
    overdrafAmount: 'Overdraft Coins',
    distribute: 'Distribute',
    recharge: 'Recharge',
    accountId: ' Enter the account ID',
    differentCountries: 'different countries?',
    tipsText: 'Tips: You can only recharge yourself.',
    noyourcontuer: 'The user is not from your country',
    rubyOverdraft: 'Overdraft Rubies',
    Amount: 'Input the amount you want to  transfer',
    sendPl: 'Max 9999999 in 1 time',
    totalTips: 'Please enter the transfer amount',
    transfer: 'Transfer',
    coin_transfer: 'Coin transfer',
    available_coins: 'Available coins',
    input_user_id_tips1: 'Input the user ID you want to transfer',
    search_for_user: 'Search for user',
    search: 'Search',
    search_for_user_toast1: 'Please input user ID',
    search_for_user_toast2: 'User does not exist',
    input_transfer_coins_tips1: 'Input the amount you want to transfer',
    transfer_toast1: 'Please input transfer amount',
    tips: 'TIPS',
    transfer_pop_up: 'Confirm to transfer {0} coins to ID:{1}',
    confirm: 'Confirm',
    cancel: 'Cancel',
    transfer_toast2: 'This user is not in the same region as you and cannot transfer coins.',
    transfer_toast3: 'Insufficient coins balance, transfer failed',
    transfer_toast4: 'Transfer successfully',
    transfer_message1: '{0} (ID: {1}) has transferred {2} coins to you. Please check your wallet.',
    transfer_toast5: 'Transfer failed, please try again later',
    entering_the_room: 'Entering the room',
    entering_the_room_toast1: 'The room does not exist',
    entering_the_room_toast2: 'You have been banned from entering the room',
    entering_the_room_toast3: 'Cannot enter rooms that are not in the same region',
    entering_the_room_toast4: 'Failed to enter the room, please try again later',
    add_blacklist_pop_up:
      'After adding to the blacklist, you will no longer receive messages from this user',
    remove_from_blacklist: 'Remove from blacklist',
    go_after: 'Go after',
    bio_empty_contents: 'This person is mysterious and left nothing. ',
    received: 'Received',
    sent: 'Sent',
    day: 'day',
    days: 'days',
    supporters: 'Supporters',
    vehicle: 'Vehicle',
    headwear: 'Headwear',
    gift: 'Gift',
    no_medal_yet: 'No medal yet',
    no_vehicle_yet: 'No vehicle yet',
    no_headwear_yet: 'No headwear yet',
    no_gifts_received_yet: 'No gifts received yet',
    home: 'Home',
  },
  tr: {
    gold: 'Altın paralar',
    ruby: 'Yakut',
    gRc: 'Altın paralar rekoru',
    rRc: 'Yakut Kaydı',
    enterId: 'Lütfen dağıtılacak kullanıcı kimliğini girin',
    useG: 'Mevcut altın sayısı',
    useR: 'Mevcut yakut sayısı',
    enterG: 'Lütfen dağıtılacak altın miktarını giriniz',
    enterR: 'Lütfen dağıtılacak yakut sayısını girin',
    appropriateG: 'altın para gönder',
    appropriateR: 'yakut gönder',
    send: 'Gönderen ',
    rec: 'Alıcı',
    time: 'Zaman',
    more: 'Daha',
    noNation:
      'Yalnızca ülkenizdeki kullanıcılardan yükleme yapabilirsiniz. Kullanıcı ülkenizde değilse, eklemek için lütfen yöneticiyle iletişime geçin.',
    opSuc: 'İşlem başarılı',
    noSearch: 'Kullanıcı bulunamıyor',
    isSend: (txt) => {
      return `Bu kullanıcıya hediye olarak ${txt} altın vereceğinizden emin misiniz?`
    },
    yes: 'onaylamak',
    no: 'iptal etmek',
    noUid: 'kullanıcı kimliği boş olamaz!!',
    loginOut: 'Oturumu Kapat',
    usableCoins: 'Kullanılabilir Altınlar',
    overdrafAmount: 'Kredili Mevduat Tutarı',
    distribute: 'Dağıt',
    recharge: 'Yükleme Yap',
    accountId: "Hesap ID'nizi girin",
    differentCountries: 'Farklı Ülkeler?',
    tipsText: 'Uyarı:Yalnızca kendiniz yükleme yapabilirsiniz.',
    noyourcontuer: 'Kullanıcı sizin ülkenizden değil',
    rubyOverdraft: 'Kredili mevduat yakutları',
    Amount: 'Aktarmak istediğiniz tutarı girin',
    sendPl: '1 kez maksimum 9999999',
    totalTips: 'Lütfen transfer tutarını girin',
    transfer: 'Transfer',
    coin_transfer: 'Altın Gönder',
    available_coins: 'Mevcut Altın',
    input_user_id_tips1: 'Altın Göndermek İstediğiniz ID',
    search_for_user: 'Kullanıcı Ara',
    search: 'Ara',
    search_for_user_toast1: 'Lütfen Kullanıcı ID Giriniz',
    search_for_user_toast2: 'Kullanıcı Mevcut Değil',
    input_transfer_coins_tips1: 'Aktarmak İstediğiniz Tutarı Giriniz',
    transfer_toast1: 'Lütfen Tutarı Giriniz',
    tips: 'Uyarı',
    transfer_pop_up: "{0} ID'ye Altın Aktarılmasını Onaylayın:{1}",
    confirm: 'Onayla',
    cancel: 'İptal',
    transfer_toast2: 'Bu kullanıcı sizinle aynı ülkede değil ve altın transferi yapılamıyor.',
    transfer_toast3: 'Yetersiz Altın Bakiyesi, Transfer Başarısız Oldu',
    transfer_toast4: 'Başarıyla Aktarıldı',
    transfer_message1: '{0} (ID: {1}) size {2} Altın Gönderdi. Lütfen Cüzdanınızı Kontrol Ediniz.',
    transfer_toast5: 'Aktarım başarısız oldu, lütfen daha sonra tekrar deneyin',
    entering_the_room: 'Odaya Giriş Yapıldı',
    entering_the_room_toast1: 'Oda Mevcut Değil',
    entering_the_room_toast2: 'Odaya Girmeniz Yasaklandı',
    entering_the_room_toast3: 'Aynı Ülkede Olmayan Odalara Girilemez',
    entering_the_room_toast4: 'Odaya girilemedi, lütfen daha sonra tekrar deneyin',
    add_blacklist_pop_up: 'Engelledikten sonra artık bu kullanıcıdan mesaj almayacaksınız',
    remove_from_blacklist: 'Engellemeyi Kaldır',
    go_after: 'Sonra Git',
    bio_empty_contents: 'Biografi Eklenmedi.',
    received: 'Alınmış',
    sent: 'Gönder',
    day: 'Gün',
    days: 'Günler',
    supporters: 'Destekçiler',
    vehicle: 'Araçlar',
    headwear: 'Çerçeveler',
    gift: 'Hediyeler',
    no_medal_yet: 'Henüz Madalya Yok',
    no_vehicle_yet: 'Henüz Araç Yok',
    no_headwear_yet: 'Henüz Çerçeve Yok',
    no_gifts_received_yet: 'Henüz Hediye Alınmadı',
    home: 'Ev',
  },
  ar: {
    gold: 'ذهب',
    ruby: 'ياقوت',
    gRc: 'سجل  عملة الذهب',
    rRc: 'سجلات ياقوت',
    enterId: 'الرجاء إدخال الايدي  المستخدم ليتم تعيينه',
    useG: 'كمية الذهب المتاحة',
    useR: 'عدد الياقوت المتاحة',
    enterG: 'الرجاء إدخال كمية من الذهب الموزع',
    enterR: 'الرجاء إدخال عدد الياقوت الذي تم توزيعه',
    appropriateG: 'توزيع الذهب',
    appropriateR: 'توزيع الياقوت',
    send: 'المرسل',
    rec: 'الاستقبال',
    time: 'الوقت',
    more: 'أكثر',
    noNation:
      'يمكن للمستخدمين فقط في بلدك إعادة الشحن. إذا لم يكن المستخدم في بلدك، فيرجى الاتصال بالمسؤول لإضافة',
    opSuc: 'عملية ناجحة',
    noSearch: 'لا يمكن العثور على المستخدم',
    isSend: (txt) => {
      return `هل أنت متأكد من الهدية ${txt} لهذا المستخدم`
    },
    yes: 'أكد',
    no: 'إلغاء',
    noUid: 'لا يمكن أن تكون فارغة!!',
    loginOut: 'الخروج',
    usableCoins: 'كونزات صالحة للاستعمال',
    overdrafAmount: 'مبلغ السحب على المكشوف',
    distribute: 'توزيع',
    recharge: 'إعادة الشحن',
    accountId: 'أدخل أيدي الحساب',
    differentCountries: 'دول مختلفة؟',
    tipsText: 'نصائح: يمكنك إعادة شحن لنفسك فقط.',
    noyourcontuer: 'المستخدم ليس من بلدك',
    rubyOverdraft: 'ياقوت السحب على المكشوف',
    Amount: 'أدخل المبلغ الذي تريد تحويله',
    sendPl: 'ماكس 9999999 في 1 مرة',
    totalTips: 'الرجاء إدخال مبلغ التحويل',
    transfer: 'توزيع',
    coin_transfer: 'توزيع الكونزات ',
    available_coins: 'الكونزات المتاحة',
    input_user_id_tips1: 'ادخل ID المستخدم الذي تريد توزيع الكونزات إليه',
    search_for_user: 'بحث المستخدم',
    search: 'بحث',
    search_for_user_toast1: 'ادخل ID المستخدم',
    search_for_user_toast2: 'المستخدم غير موجود',
    input_transfer_coins_tips1: 'ادخل المبلغ الذي تريد تحويله',
    transfer_toast1: 'ادخل المبلغ الذي تريد تحويله',
    tips: 'نصيحة',
    transfer_pop_up: 'تأكيد توزيع {0} كونزات إلى المعرف:{1}',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    transfer_toast2: 'المستخدم ليس مستخدما في نفس المنطقة التي تكون فيها ، ولا يمكن إجراء التوزيع',
    transfer_toast3: 'رصيد الكونزات غير كاف ، وفشل التوزيع',
    transfer_toast4: 'تم التوزيع بنجاح',
    transfer_message1: '{0} (المعرف: {1}) قام بتوزيع {2} كونزات إليك ، يرجى تحقق في محفظتك',
    transfer_toast5: 'فشل إعادة الشحن، يرجى إعادة المحاولة لاحقا',
    entering_the_room: 'في عملية  دخول الغرفة',
    entering_the_room_toast1: 'الغرفة غير موجودة',
    entering_the_room_toast2: 'تم منعك من دخول الغرفة',
    entering_the_room_toast3: 'لا يمكن الدخول إلى غرف ليست في نفس المنطقة',
    entering_the_room_toast4: 'فشل في دخول الغرفة، يرجى المحاولة مرة أخرى في وقت لاحق',
    add_blacklist_pop_up:
      'بمجرد إدراجك في القائمة السوداء ، لن تتلقى رسائل من هذا المستخدم بعد الآن',
    remove_from_blacklist: 'تمت إزالته من القائمة السوداء',
    go_after: 'اتبع في الغرفة',
    bio_empty_contents: 'كان الرجل غامضا ولم يترك شيئا.',
    received: 'تم  الاستلام',
    sent: 'تم إرسال',
    day: 'يوم',
    days: 'أيام',
    supporters: 'داعمون',
    vehicle: 'دخولية',
    headwear: 'إطار',
    gift: 'هدايا',
    no_medal_yet: 'لا توجد ميدالية حتى الآن',
    no_vehicle_yet: 'لا توجد دخولية حتى الآن',
    no_headwear_yet: 'لا توجد إطار حتى الآن',
    no_gifts_received_yet: 'لم تتلقى الهدية بعد',
    home: 'الغرفة',
  },
  pt: {
    gold: 'Ouro',
    ruby: 'Rubi',
    gRc: 'Registro de Ouro',
    rRc: 'Registro de Rubi',
    enterId: 'Por favor, insira o ID do usuário para distribuir',
    useG: 'Moedas Usáveis',
    useR: 'Número de rubis disponíveis',
    enterG: 'Por favor, insira a quantidade de ouro a ser distribuída',
    enterR: 'Por favor, insira o número de rubis a ser distribuído',
    appropriateG: 'Distribuir ouro',
    appropriateR: 'Distribuir rubi',
    send: 'Remetente',
    rec: 'Destinatário',
    time: 'Hora',
    more: 'Mais',
    noNation:
      'Você só pode recarregar usuários no seu país. Se o usuário não estiver no seu país, entre em contato com o administrador para adicionar',
    opSuc: 'Operação bem-sucedida',
    noSearch: 'O usuário não pode ser encontrado',
    isSend: (txt) => {
      return `Tem certeza de que deseja dar ${txt} moedas de ouro a este usuário como presente?`
    },
    yes: 'Confirmar',
    no: 'Cancelar',
    noUid: 'UID não pode estar vazio!!',
    loginOut: 'Sair',
    usableCoins: 'Moedas Usáveis',
    overdrafAmount: 'Moedas de Adiantamento',
    distribute: 'Distribuir',
    recharge: 'Recarregar',
    accountId: 'Digite o ID da conta',
    differentCountries: 'países diferentes?',
    tipsText: 'Dicas: Você só pode recarregar a si mesmo.',
    noyourcontuer: 'O usuário não é do seu país',
    rubyOverdraft: 'Adiantamento de Rubis',
    Amount: 'Digite o valor que deseja transferir',
    sendPl: 'Máximo 9999999 em 1 vez',
    totalTips: 'Por favor, insira o valor da transferência',
    transfer: 'Transferir',
    coin_transfer: 'Transferência de Moedas',
    available_coins: 'Moedas disponíveis',
    input_user_id_tips1: 'Digite o ID do usuário para o qual deseja transferir',
    search_for_user: 'Buscar usuário',
    search: 'Buscar',
    search_for_user_toast1: 'Por favor, insira o ID do usuário',
    search_for_user_toast2: 'Usuário não existe',
    input_transfer_coins_tips1: 'Digite o valor que deseja transferir',
    transfer_toast1: 'Por favor, insira o valor da transferência',
    tips: 'DICAS',
    transfer_pop_up: 'Confirmar para transferir {0} moedas para o ID: {1}',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    transfer_toast2: 'Este usuário não está na mesma região que você e não pode transferir moedas.',
    transfer_toast3: 'Saldo insuficiente de moedas, transferência falhou',
    transfer_toast4: 'Transferência realizada com sucesso',
    transfer_message1:
      '{0} (ID: {1}) transferiu {2} moedas para você. Por favor, verifique sua carteira.',
    transfer_toast5: 'Falha na transferência, por favor tente novamente mais tarde',
    entering_the_room: 'Entrando na sala',
    entering_the_room_toast1: 'A sala não existe',
    entering_the_room_toast2: 'Você foi banido de entrar na sala',
    entering_the_room_toast3: 'Não é possível entrar em salas que não estão na mesma região',
    entering_the_room_toast4: 'Falha ao entrar na sala, por favor tente novamente mais tarde',
    add_blacklist_pop_up:
      'Após adicionar à lista negra, você não receberá mais mensagens deste usuário',
    remove_from_blacklist: 'Remover da lista negra',
    go_after: 'Seguir',
    bio_empty_contents: 'Esta pessoa é misteriosa e não deixou nada.',
    received: 'Recebido',
    sent: 'Enviado',
    day: 'dia',
    days: 'dias',
    supporters: 'Apoiadores',
    vehicle: 'Veículo',
    headwear: 'Acessório de cabeça',
    gift: 'Presente',
    no_medal_yet: 'Ainda sem medalha',
    no_vehicle_yet: 'Ainda sem veículo',
    no_headwear_yet: 'Ainda sem acessório de cabeça',
    no_gifts_received_yet: 'Ainda sem presentes recebidos',
    home: 'Início',
  },
  id: {
    gold: 'Emas',
    ruby: 'Ruby',
    gRc: 'Catatan Emas',
    rRc: 'Catatan Ruby',
    enterId: 'Silakan masukkan ID pengguna untuk distribusi',
    useG: 'Koin yang dapat digunakan',
    useR: 'Jumlah ruby yang tersedia',
    enterG: 'Silakan masukkan jumlah emas yang akan didistribusikan',
    enterR: 'Silakan masukkan jumlah ruby yang akan didistribusikan',
    appropriateG: 'Distribusikan emas',
    appropriateR: 'Distribusikan Ruby',
    send: 'Pengirim',
    rec: 'Penerima',
    time: 'Waktu',
    more: 'Lebih banyak',
    noNation:
      'Anda hanya dapat mengisi ulang pengguna di negara Anda. Jika pengguna tidak berada di negara Anda, silakan hubungi administrator untuk menambahkannya',
    opSuc: 'Operasi berhasil',
    noSearch: 'Pengguna tidak dapat ditemukan',
    isSend: (txt) => {
      return `Apakah Anda yakin ingin memberikan ${txt} koin emas kepada pengguna ini sebagai hadiah`
    },
    yes: 'konfirmasi',
    no: 'batal',
    noUid: 'uid tidak boleh kosong!!',
    loginOut: 'Keluar dari login',
    usableCoins: 'Koin yang dapat digunakan',
    overdrafAmount: 'Koin Overdraft',
    distribute: 'Distribusikan',
    recharge: 'Isi ulang',
    accountId: 'Masukkan ID akun',
    differentCountries: 'negara yang berbeda?',
    tipsText: 'Tips: Anda hanya dapat mengisi ulang diri Anda sendiri.',
    noyourcontuer: 'Pengguna bukan dari negara Anda',
    rubyOverdraft: 'Overdraft Ruby',
    Amount: 'Masukkan jumlah yang ingin Anda transfer',
    sendPl: 'Maks 9999999 dalam 1 kali',
    totalTips: 'Silakan masukkan jumlah transfer',
    transfer: 'Transfer',
    coin_transfer: 'Transfer Koin',
    available_coins: 'Koin yang tersedia',
    input_user_id_tips1: 'Masukkan ID pengguna yang ingin Anda transfer',
    search_for_user: 'Cari pengguna',
    search: 'Cari',
    search_for_user_toast1: 'Silakan masukkan ID pengguna',
    search_for_user_toast2: 'Pengguna tidak ada',
    input_transfer_coins_tips1: 'Masukkan jumlah yang ingin Anda transfer',
    transfer_toast1: 'Silakan masukkan jumlah transfer',
    tips: 'TIPS',
    transfer_pop_up: 'Konfirmasi untuk mentransfer {0} koin ke ID:{1}',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    transfer_toast2:
      'Pengguna ini tidak berada di wilayah yang sama dengan Anda dan tidak dapat mentransfer koin.',
    transfer_toast3: 'Saldo koin tidak cukup, transfer gagal',
    transfer_toast4: 'Transfer berhasil',
    transfer_message1:
      '{0} (ID: {1}) telah mentransfer {2} koin kepada Anda. Silakan periksa dompet Anda.',
    transfer_toast5: 'Transfer gagal, silakan coba lagi nanti',
    entering_the_room: 'Masuk ke ruang',
    entering_the_room_toast1: 'Ruang tidak ada',
    entering_the_room_toast2: 'Anda telah diblokir untuk masuk ke ruang',
    entering_the_room_toast3: 'Tidak dapat masuk ke ruang yang tidak berada di wilayah yang sama',
    entering_the_room_toast4: 'Gagal masuk ruang, silakan coba lagi nanti',
    add_blacklist_pop_up:
      'Setelah ditambahkan ke daftar hitam, Anda tidak akan lagi menerima pesan dari pengguna ini',
    remove_from_blacklist: 'Hapus dari daftar hitam',
    go_after: 'Pergi setelah',
    bio_empty_contents: 'Orang ini misterius dan meninggalkan tidak ada apa-apa.',
    received: 'Diterima',
    sent: 'Dikirim',
    day: 'hari',
    days: 'hari',
    supporters: 'Pendukung',
    vehicle: 'Kendaraan',
    headwear: 'Aksesori Kepala',
    gift: 'Hadiah',
    no_medal_yet: 'Belum ada medali',
    no_vehicle_yet: 'Belum ada kendaraan',
    no_headwear_yet: 'Belum ada aksesori kepala',
    no_gifts_received_yet: 'Belum ada hadiah diterima',
    home: 'Beranda',
  },
  uz: {
    gold: 'Oltin',
    ruby: 'Rubin',
    gRc: 'Oltin Yozuv',
    rRc: 'Rubin Yozuv',
    enterId: 'Iltimos, tarqatish uchun foydalanuvchi ID-ni kiriting',
    useG: 'Ishlatiladigan tangalar',
    useR: 'Mavjud rubinlar soni',
    enterG: 'Iltimos, tarqatiladigan oltin miqdorini kiriting',
    enterR: 'Iltimos, tarqatiladigan rubinlar sonini kiriting',
    appropriateG: 'Oltin tarqatish',
    appropriateR: 'Rubin tarqatish',
    send: "Jo'natuvchi",
    rec: 'Qabul qiluvchi',
    time: 'Vaqt',
    more: "Ko'proq",
    noNation:
      "Siz faqat o'zingizning mamlakatingizdagi foydalanuvchilarga to'lov qila olasiz. Agar foydalanuvchi boshqa mamlakatda bo'lsa, iltimos, administrator bilan bog'laning",
    opSuc: 'Amal muvaffaqiyatli bajarildi',
    noSearch: 'Foydalanuvchi topilmadi',
    isSend: (txt) => {
      return `Siz haqiqatan ham bu foydalanuvchiga ${txt} oltin tangalarini sovg'a sifatida berishga rozimisiz?`
    },
    yes: 'Tasdiqlash',
    no: 'Bekor qilish',
    noUid: "UID bo'sh bo'lishi mumkin emas!!",
    loginOut: 'Chiqish',
    usableCoins: 'Ishlatiladigan tangalar',
    overdrafAmount: 'Ortga olish tangalari',
    distribute: 'Tarqatish',
    recharge: 'Yuklash',
    accountId: 'Hisob ID-ni kiriting',
    differentCountries: 'Boshqa mamlakatlardanmi?',
    tipsText: "Maslahat: Faqat o'zingizga to'lov qila olasiz.",
    noyourcontuer: 'Foydalanuvchi sizning mamlakatingizdan emas',
    rubyOverdraft: 'Rubinlarni ortga olish',
    Amount: "O'tkazmoqchi bo'lgan miqdorni kiriting",
    sendPl: 'Bir martada maksimal 9999999',
    totalTips: "O'tkazmoqchi bo'lgan miqdorni kiriting",
    transfer: "O'tkazish",
    coin_transfer: "Tanga o'tkazish",
    available_coins: 'Mavjud tangalar',
    input_user_id_tips1: "O'tkazmoqchi bo'lgan foydalanuvchi ID-ni kiriting",
    search_for_user: 'Foydalanuvchini qidiring',
    search: 'Qidirish',
    search_for_user_toast1: 'Iltimos, foydalanuvchi ID-ni kiriting',
    search_for_user_toast2: 'Foydalanuvchi mavjud emas',
    input_transfer_coins_tips1: "O'tkazmoqchi bo'lgan miqdorni kiriting",
    transfer_toast1: "Iltimos, o'tkazish miqdorini kiriting",
    tips: 'MASLAHAT',
    transfer_pop_up: "ID:{1} ga {0} tangalarini o'tkazishni tasdiqlaysizmi?",
    confirm: 'Tasdiqlash',
    cancel: 'Bekor qilish',
    transfer_toast2:
      "Bu foydalanuvchi siz bilan bir xil hududda emas va tangalar o'tkazib bo'lmaydi.",
    transfer_toast3: "Tangalar balansining yetishmasligi, o'tkazish muvaffaqiyatsiz bo'ldi",
    transfer_toast4: "O'tkazish muvaffaqiyatli bajarildi",
    transfer_message1: "{0} (ID: {1}) sizga {2} tanga o'tkazdi. Iltimos, hamyoningizni tekshiring.",
    transfer_toast5: "O'tkazish muvaffaqiyatsiz, iltimos, keyinroq qayta urinib ko'ring",
    entering_the_room: 'Xonaga kirish',
    entering_the_room_toast1: 'Xona mavjud emas',
    entering_the_room_toast2: 'Siz xonaga kirishga taqiqlangansiz',
    entering_the_room_toast3: "Bir xil hududda bo'lmagan xonalarga kira olmaysiz",
    entering_the_room_toast4: "Xonaga kira olmadi, iltimos, keyinroq qayta urinib ko'ring",
    add_blacklist_pop_up:
      "Qora ro'yxatga qo'shgandan so'ng, siz bu foydalanuvchidan xabarlar olmasligingiz kerak",
    remove_from_blacklist: "Qora ro'yxatdan olib tashlash",
    go_after: 'Keyingi',
    bio_empty_contents: 'Bu odam sirli va hech narsa qoldirmadi.',
    received: 'Olingan',
    sent: 'Yuborilgan',
    day: 'kun',
    days: 'kunlar',
    supporters: "Qo'llab-quvvatlovchilar",
    vehicle: 'Transport',
    headwear: 'Bosqich kiyimi',
    gift: "Sovg'a",
    no_medal_yet: 'Henüz medal yok',
    no_vehicle_yet: 'Henüz araç yok',
    no_headwear_yet: 'Henüz başlık yok',
    no_gifts_received_yet: 'Henüz hediye almadınız',
    home: 'Bosh sahifa',
  },
  ru: {
    gold: 'Золото',
    ruby: 'Рубин',
    gRc: 'Золотой Рекорд',
    rRc: 'Рубиновый Рекорд',
    enterId: 'Пожалуйста, введите ID пользователя для распределения',
    useG: 'Доступные монеты',
    useR: 'Количество доступных рубинов',
    enterG: 'Пожалуйста, введите количество золота для распределения',
    enterR: 'Пожалуйста, введите количество рубинов для распределения',
    appropriateG: 'Распределить золото',
    appropriateR: 'Распределить рубины',
    send: 'Отправитель',
    rec: 'Получатель',
    time: 'Время',
    more: 'Больше',
    noNation:
      'Вы можете пополнять только пользователей своей страны. Если пользователь не из вашей страны, обратитесь к администратору для добавления',
    opSuc: 'Операция успешна',
    noSearch: 'Пользователь не найден',
    isSend: (txt) => {
      return `'Вы уверены, что хотите отправить ${txt} золотых монет этому пользователю в подарок?'`
    },
    yes: 'Подтвердить',
    no: 'Отменить',
    noUid: 'UID не может быть пустым!!',
    loginOut: 'Выход',
    usableCoins: 'Доступные монеты',
    overdrafAmount: 'Перерасход монет',
    distribute: 'Распределить',
    recharge: 'Пополнить',
    accountId: 'Введите ID аккаунта',
    differentCountries: 'Другие страны?',
    tipsText: 'Подсказка: вы можете пополнять только себя.',
    noyourcontuer: 'Пользователь не из вашей страны',
    rubyOverdraft: 'Перерасход рубинов',
    Amount: 'Введите сумму для перевода',
    sendPl: 'Максимум 9999999 за один раз',
    totalTips: 'Пожалуйста, введите сумму перевода',
    transfer: 'Перевести',
    coin_transfer: 'Перевод монет',
    available_coins: 'Доступные монеты',
    input_user_id_tips1: 'Введите ID пользователя, которому хотите перевести',
    search_for_user: 'Поиск пользователя',
    search: 'Поиск',
    search_for_user_toast1: 'Пожалуйста, введите ID пользователя',
    search_for_user_toast2: 'Пользователь не существует',
    input_transfer_coins_tips1: 'Введите сумму для перевода',
    transfer_toast1: 'Пожалуйста, введите сумму перевода',
    tips: 'ПОСОВЕТУЙТЕ',
    transfer_pop_up: 'Подтвердите перевод {0} монет на ID:{1}',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    transfer_toast2: 'Этот пользователь не в вашем регионе, перевод невозможен.',
    transfer_toast3: 'Недостаточно монет, перевод не удался',
    transfer_toast4: 'Перевод успешен',
    transfer_message1: '{0} (ID: {1}) перевел вам {2} монет. Пожалуйста, проверьте свой кошелек.',
    transfer_toast5: 'Перевод не удался, попробуйте позже',
    entering_the_room: 'Вход в комнату',
    entering_the_room_toast1: 'Комната не существует',
    entering_the_room_toast2: 'Вам запрещено входить в эту комнату',
    entering_the_room_toast3: 'Нельзя войти в комнаты другого региона',
    entering_the_room_toast4: 'Не удалось войти в комнату, попробуйте позже',
    add_blacklist_pop_up:
      'После добавления в черный список, вы больше не будете получать сообщения от этого пользователя',
    remove_from_blacklist: 'Удалить из черного списка',
    go_after: 'Перейти после',
    bio_empty_contents: 'Этот человек таинственен и ничего не оставил.',
    received: 'Получено',
    sent: 'Отправлено',
    day: 'день',
    days: 'дней',
    supporters: 'Поддержка',
    vehicle: 'Транспортное средство',
    headwear: 'Головной убор',
    gift: 'Подарок',
    no_medal_yet: 'Пока нет медалей',
    no_vehicle_yet: 'Пока нет транспорта',
    no_headwear_yet: 'Пока нет головного убора',
    no_gifts_received_yet: 'Пока нет полученных подарков',
    home: 'Главная',
  },
  fa: {
    gold: 'طلا',
    ruby: 'یاقوت',
    gRc: 'رکورد طلا',
    rRc: 'رکورد یاقوت',
    enterId: 'لطفاً شناسه کاربری برای توزیع را وارد کنید',
    useG: 'سکه‌های قابل استفاده',
    useR: 'تعداد یاقوت‌های موجود',
    enterG: 'لطفاً مقدار طلا برای توزیع را وارد کنید',
    enterR: 'لطفاً تعداد یاقوت‌ها برای توزیع را وارد کنید',
    appropriateG: 'توزیع طلا',
    appropriateR: 'توزیع یاقوت',
    send: 'فرستنده',
    rec: 'گیرنده',
    time: 'زمان',
    more: 'بیشتر',
    noNation:
      'شما فقط می‌توانید کاربران کشور خود را شارژ کنید. اگر کاربر در کشور شما نیست، لطفاً با مدیر تماس بگیرید',
    opSuc: 'عملیات با موفقیت انجام شد',
    noSearch: 'کاربر پیدا نشد',
    isSend: (txt) => {
      return `'آیا مطمئن هستید که ${txt} سکه طلا به این کاربر به عنوان هدیه می‌دهید؟'`
    },
    yes: 'تأیید',
    no: 'لغو',
    noUid: 'شناسه UID نمی‌تواند خالی باشد!!',
    loginOut: 'خروج',
    usableCoins: 'سکه‌های قابل استفاده',
    overdrafAmount: 'مقدار سکه‌های قرضی',
    distribute: 'توزیع',
    recharge: 'شارژ',
    accountId: 'شناسه حساب را وارد کنید',
    differentCountries: 'کشورهای مختلف؟',
    tipsText: 'نکته: فقط می‌توانید خودتان را شارژ کنید.',
    noyourcontuer: 'این کاربر از کشور شما نیست',
    rubyOverdraft: 'یاقوت قرضی',
    Amount: 'مقداری که می‌خواهید انتقال دهید را وارد کنید',
    sendPl: 'حداکثر 9999999 در یک بار',
    totalTips: 'لطفاً مبلغ انتقال را وارد کنید',
    transfer: 'انتقال',
    coin_transfer: 'انتقال سکه',
    available_coins: 'سکه‌های موجود',
    input_user_id_tips1: 'شناسه کاربری که می‌خواهید انتقال دهید را وارد کنید',
    search_for_user: 'جستجوی کاربر',
    search: 'جستجو',
    search_for_user_toast1: 'لطفاً شناسه کاربری را وارد کنید',
    search_for_user_toast2: 'کاربر وجود ندارد',
    input_transfer_coins_tips1: 'لطفاً مقدار انتقال را وارد کنید',
    transfer_toast1: 'لطفاً مبلغ انتقال را وارد کنید',
    tips: 'نکات',
    transfer_pop_up: 'آیا تأیید می‌کنید که {0} سکه را به شناسه:{1} انتقال دهید؟',
    confirm: 'تأیید',
    cancel: 'لغو',
    transfer_toast2: 'این کاربر در منطقه شما نیست و نمی‌توانید سکه‌ها را انتقال دهید.',
    transfer_toast3: 'مقدار سکه کافی نیست، انتقال ناموفق',
    transfer_toast4: 'انتقال با موفقیت انجام شد',
    transfer_message1:
      '{0} (شناسه: {1}) {2} سکه به شما منتقل کرده است. لطفاً کیف پول خود را بررسی کنید.',
    transfer_toast5: 'انتقال ناموفق، لطفاً بعداً دوباره تلاش کنید',
    entering_the_room: 'وارد شدن به اتاق',
    entering_the_room_toast1: 'اتاق وجود ندارد',
    entering_the_room_toast2: 'شما از ورود به این اتاق منع شده‌اید',
    entering_the_room_toast3: 'نمی‌توانید به اتاق‌هایی که در منطقه شما نیستند وارد شوید',
    entering_the_room_toast4: 'ورود به اتاق ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    add_blacklist_pop_up: 'پس از اضافه شدن به لیست سیاه، دیگر از این کاربر پیام دریافت نخواهید کرد',
    remove_from_blacklist: 'حذف از لیست سیاه',
    go_after: 'دنبال کردن',
    bio_empty_contents: 'این شخص مرموز است و هیچ چیزی باقی نگذاشته است.',
    received: 'دریافت شده',
    sent: 'ارسال شده',
    day: 'روز',
    days: 'روزها',
    supporters: 'حامیان',
    vehicle: 'وسیله نقلیه',
    headwear: 'کلاه',
    gift: 'هدیه',
    no_medal_yet: 'هنوز مدالی وجود ندارد',
    no_vehicle_yet: 'هنوز وسیله نقلیه‌ای وجود ندارد',
    no_headwear_yet: 'هنوز کلاهی وجود ندارد',
    no_gifts_received_yet: 'هنوز هدیه‌ای دریافت نکرده‌اید',
    home: 'خانه',
  },
}



// WEBPACK FOOTER //
// src/pages/app/ruby-agent/lang.js